import { ArrowCircleUp } from "@mui/icons-material";
import React from "react";

const ScrollToTop = () => {
  const scrolltoTopHandler = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div
      className=" fixed bottom-5 right-5 rounded-full p-2 cursor-pointer z-50"
      onClick={scrolltoTopHandler}
    >
      <ArrowCircleUp className="text-white text-2xl scrollToTop" />
    </div>
  );
};

export default ScrollToTop;
